import Loader from "react-loader-spinner";

const BtnLoading = () => {
  return (
    <div className="btnLoading">
      <span className="me-3">Loading...</span>
      <Loader
        type="Bars"
        color="#FCD20C"
        height={20}
        width={45}
      />
    </div>
  )
}
export default BtnLoading